export interface QuestionProps {
  id: string;
  question: string;
  answerTitle: string;
  answer: string;
  isSelected: boolean
}

export const questions: QuestionProps[] = [
  {
    id: '1',
    question: '이미 세무관리 받고 있는데 환급 받을 수 있나요?',
    answerTitle: '세금 환급은 기존 세무사 유무와 상관 없이 받을 수 있습니다.',
    answer: '세금 환급 전문 세무사가 진행하는게 정확하고 안전합니다. 200여가지의 세제혜택을 정확하게 알고 분석해서 각 기업에 맞게 적용해야 정확하고 안전하게 환급 받을 수 있습니다.',
    isSelected: false,
  },
  {
    id: '2',
    question: '정말 믿고 맡겨도 괜찮은건가요?',
    answerTitle: '혜움은 기장 및 세금 환급 전문가팀을 별도로 구성해 운영하고 있습니다.',
    answer: '혜움은 전국 26개의 지점, 전문 세무사 및 회계사 30여명, 거래처 3,000여 곳 이상 보유하고 있는 믿을 수 있는 세무법인입니다.',
    isSelected: false,
  },
  {
    id: '3',
    question: '세금 환급 받으면 세무조사 받지 않을까요?',
    answerTitle: '세금을 환급 받는다고 세무조사를 받지 않습니다.',
    answer: '국세청은 세금 환급 관련 항목에 대해서만 검토할 수 있기때문에 세무조사 대상 여부를 판단할 수 없습니다.',
    isSelected: false,
  },
  {
    id: '4',
    question: '환급 받는데 얼마나 시간이 걸리고 비용은 얼마인가요?',
    answerTitle: '환급 대상자 확인은 5분, 최종환급까지 1~3개월 소요\n이용 수수료는 환급액의 30%',
    answer: '자세한 내용은 상담을 통해 정확하게 확인할 수 있습니다.',
    isSelected: false,
  },
  {
    id: '5',
    question: '체납세액이 있는데 환급 받을 수 있을까요?',
    answerTitle: '환급 받을 수 있습니다.',
    answer: '체납세액과 무관하게 더 낸 세금이 있다면 환급 받을 수 있습니다.',
    isSelected: false,
  },
  {
    id: '6',
    question: '홈택스에 환급금이 없다고 나오면 환급 못받는건가요?',
    answerTitle: '환급 받을 수 있습니다.',
    answer: '잘못 신고되거나 누락된 세제 혜택에 대한 환급금이 있는경우 환급 받을 수 있습니다.',
    isSelected: false,
  },
  {
    id: '7',
    question: '더낸세금에서 종합소득세, 법인세 환급을 받을 수 있나요?',
    answerTitle: '환급 받을 수 있습니다.',
    answer: '개인사업자의 경우 최근 5년 간 납부한 종합소득세 신고 내역, 법인사업자의 경우 최근 5년 간 납부한 법인세 신고 내역을 자체 알고리즘으로 전문 세무사가 검토하여 환급금을 진단합니다.',
    isSelected: false,
  },
]
